import * as React from "react";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { AssetLink } from "./AssetLink.js";
/* empty css                   */
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const ProductAssetsList = () => {
  const { getLabel } = useIntl();
  const { isProductAssetsOnPdpEnabled } = useFeatureToggles();
  const {
    activeVariant: { assets }
  } = useProductData();
  if (!isProductAssetsOnPdpEnabled || assets.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "product-detail-manufacturer__content-section" }, /* @__PURE__ */ React.createElement(Text, { variant: "body-head", spacings: ["mb-0"], component: "h3" }, getLabel("products.detail.manufacturer.assetsTitle")), /* @__PURE__ */ React.createElement("ul", { className: "product-assets-list" }, assets.map((asset, index) => {
    return /* @__PURE__ */ React.createElement(AssetLink, { key: index, asset });
  })));
};
export {
  ProductAssetsList
};
//# sourceMappingURL=ProductAssetsList.js.map
